module.exports = __webpack_public_path__ + "static/media/nps_one_time_icon.67cce723.svg";